export default __webpack_public_path__ + "static/media/Nishi_Bhonsle_AHV_In_Moms_We_Trust.79dc5979.jpg";